import { useNavigate } from 'react-router-dom';
import { addCurrentParamsToUrl } from '../utils/urlParamUtils';

/**
 * 현재 URL 파라미터를 자동으로 복사하는 네비게이션 훅
 */
export const useSessionNavigation = () => {
  const navigate = useNavigate();

  const navigateWithSession = (path: string) => {
    const urlWithParams = addCurrentParamsToUrl(path);
    // 현재 URL의 파라미터를 복사해서 새로운 URL에 추가
    navigate(urlWithParams);
  };

  return { navigateWithSession };
};
